import React from 'react';

import getLogo from '../../utils/getLogo';
import './Logo.scss';

export const MobileLogo = () => {
  return (
    <div className="logo_mobile">
      <img src={getLogo()} className="logo__img" alt="logo" />
    </div>
  );
};
